import React from 'react';
import { usePrefixCls } from '@byte-design/config';
var headerGroup = ['00:00~12:00', '12:00~24:00'];
export function ScheduleHeader() {
  var prefix = 'schedule-header';
  var cls = usePrefixCls(prefix);
  var groupCls = usePrefixCls(prefix, {
    group: true
  }, true);
  var groupItemCls = usePrefixCls(prefix, {
    'group-item': true
  }, true);
  var hourCls = usePrefixCls(prefix, {
    hour: true
  }, true);
  var hourItemCls = usePrefixCls(prefix, {
    'hour-item': true
  }, true);

  var renderHourItems = function renderHourItems() {
    var list = [];

    for (var i = 0; i < 24; i++) {
      list.push(React.createElement("div", {
        className: hourItemCls,
        key: i
      }, i));
    }

    return list;
  };

  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: groupCls
  }, headerGroup.map(function (group) {
    return React.createElement("div", {
      key: group,
      className: groupItemCls
    }, group);
  })), React.createElement("div", {
    className: hourCls
  }, renderHourItems()));
}